import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { map, catchError } from 'rxjs/operators';
import { Observable, of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class PublishingHighlightService {
  private host =
    environment.configCMS.endPointAPI + environment.configCMS.endPointAPP;

  constructor(private router: Router, private http: HttpClient) {}

  public getConfigPublishing(): Observable<any> {
    return this.getConfigPublishingQuery().pipe(
      map(res => this.mapConfig(this.extractResult(res))),
      catchError(error => {
        console.log('error', error);
        this.router.navigate(['/nao-encontrado']);
        return of(null);
      })
    );
  }

  private extractResult(res) {
    return res.data.queryConfiguracaoPublicacoesContents[0].flatData;
  }

  private getConfigPublishingQuery(): Observable<any> {
    const payload = {
      query: `
      {
        queryConfiguracaoPublicacoesContents {
          flatData {
            cardButtonLabel
            styleButtonCardPublishing
            standardNavigationButtons {
              title
              pageLocation
              destinationPage
              icon {
                url
              }
            }
            anyPageButtons {
              title
              page {
                flatData {
                  slug
                }
              }
            }
            banner {
              __typename
              ... on Publicacoes {
                flatData {
                  imagemDestaque {
                    url
                  }
                  titulo
                  subtitulo
                }
              }
              ... on Banners {
                flatData {
                  imagem {
                    url
                  }
                  titulo
                  descricao
                }
              }
            }
          }
        }
      }`
    };

    return this.send(payload);
  }

  private mapConfig(response) {
    const anyPageButtons = response.anyPageButtons.map(item => {
      return {
        title: item.title,
        page: item.page[0] ? `/paginas/${item.page[0].flatData.slug}` : ''
      };
    });

    const banner =
      response.banner[0]?.__typename === 'Banners'
        ? {
            title: response.banner[0]?.flatData?.titulo,
            description: response.banner[0]?.flatData?.descricao,
            image: response.banner[0]?.flatData?.imagem[0].url
          }
        : response.banner[0]?.__typename === 'Publicacoes'
        ? {
            title: response.banner[0]?.flatData?.titulo,
            description: response.banner[0]?.flatData?.subtitulo,
            image: response.banner[0]?.flatData?.imagemDestaque[0].url
          }
        : null;

    const standardNavigationButtons = response.standardNavigationButtons.map(
      item => {
        return {
          destinationPage: item.destinationPage,
          icon: item.icon[0] ? item.icon[0].url : '',
          pageLocation: item.pageLocation,
          title: item.title
        };
      }
    );

    return {
      cardButtonLabel: response.cardButtonLabel,
      styleButtonCardPublishing: response.styleButtonCardPublishing,
      anyPageButtons,
      standardNavigationButtons,
      banner
    };
  }

  private send(payload): Observable<any> {
    const url = `${this.host}graphql`;
    return this.http.post(url, payload);
  }
}
